export default "__VITE_ASSET__BbzP3IL7__"